import * as React from 'react'; // TODO: check

const ToastContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {}

});
export default ToastContext;